import { createPopper } from '@popperjs/core';
let props = {
  arrow: true,
  fade: true,
  event: 'hover',
}
let options = {
  placement: 'auto',
  modifiers: [
    {
      name: 'arrow',
      options: {
        element: '[data-popper-arrow]'
      },
    },
  ],

}

export default {
  inserted(el, binding) {
    binding.value = { ...props, ...binding.value }

    el.showTooltip = () => {
      var tooltipEl = createTooltip(el, binding)
      // createPopperInstance
      let tooltipInstance = createPopperInstance(el, tooltipEl, binding)
      el.popperInstance = tooltipInstance;
      el.tooltipEl = tooltipEl;

      el.tooltipEl.classList.add('show');
    }
    el.hideTooltip = () => {
      el.tooltipEl.classList.remove('show');
      el.tooltipEl.addEventListener('transitionend', function () {
        if (el.tooltipEl) {
          el.tooltipEl.remove();
          el.tooltipEl = null;
        }
        if (el.popperInstance) {
          el.popperInstance.destroy();
          el.popperInstance = null;
        }
      });

    }
    createEventListeners(el, binding)
  },
  unbind(el) {
    if (el.tooltipEl) {
      el.tooltipEl.remove();
    }
    if (el.popperInstance) {
      el.popperInstance.destroy();
    }
  },

};
function createTooltip(el, binding) {
  var container = document.body;

  if (binding.value.container) {
    if (binding.value.container === 'parent') {
      container = el.parentElement;
    }
  }
  let tooltipEl = document.createElement('div');
  let innerHTML = '<div class="tooltip-arrow" data-popper-arrow></div><div class="tooltip-inner">' + (binding.value.html ?? binding.value.text) + '</div>'
  tooltipEl.innerHTML = innerHTML;
  tooltipEl.classList.add('tooltip');
  var placement = options.placement.replace('left', 'start').replace('right', 'end');
  tooltipEl.classList.add('bs-tooltip-' + placement);
  tooltipEl.classList.add('fade');
  container.appendChild(tooltipEl);
  return tooltipEl;

}
function createPopperInstance(el, tooltipEl, binding) {
  if (el.popperInstance) el.popperInstance.destroy();
  el.popperInstance = createPopper(el, tooltipEl, options);

}
function createEventListeners(el, binding) {
  let tooltipEl;
  console.log('createEventListeners', el, binding.value.event)
  if (binding.value.event) {
    if (binding.value.event === 'hover') {
      el.addEventListener('mouseenter', el.showTooltip);
      el.addEventListener('mouseleave', el.hideTooltip);

    }
    else if (binding.value.event === 'click') {
      el.addEventListener('click', function () {
        if (!tooltipEl.classList.contains('show')) {
          el.showTooltip()
        } else {
          el.hideTooltip()
        }

      });
    }
    else if (binding.value.event === 'focus') {
      el.addEventListener('focus', function () {
        el.showTooltip()
      });
      el.addEventListener('blur', function () {
        el.hideTooltip()
      });
    }


  }
}